import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import {BarcodesVerificationModel} from './barcodes-verification.model';
import { COMPONENT_MODE } from '../../workflow-components.models';

@Component({
  selector: 'dynamic-barcodes-verification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-barcodes-verification.component.html'
})
export class DynamicBarcodesVerificationComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: BarcodesVerificationModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  COMPONENT_MODE = COMPONENT_MODE; 
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
